<template>
    <div>
      <b-card bg-variant="light">
    <b-row>
      <b-col md="11">
        <div v-if="ams_data.attributes">
          <b-jumbotron header-level="5" bg-variant="dark" text-variant="white" border-variant="dark">
              <template #header>{{ams_data.attributes['name']}}</template>
              <template #lead>
                {{humanized_permission}}
              </template>
              <hr text-variant="white" class="my-4">
              <p>
                Image Storage Limit {{ams_data.attributes['max-images-size']}}
              </p>
              <template>
                <b-card class="mb-2" bg-variant="none" body-bg-variant="dark"> {{description}}</b-card>
              </template>
              <b-button variant="primary" @click="navigateToImageCollection">Build Portfolio...</b-button>
              <hr text-variant="white" class="my-4">
              <b-img thumbnail fluid src="https://unicorn-farm-image-asset.s3.us-east-2.amazonaws.com/intro-graytone5.png"></b-img>
          </b-jumbotron>
        </div>
      </b-col>
      <b-col md="1">
        <data-navagations
          @update="doUpdate"
          @cancel="doCancel"
          @help="doHelp"
        ></data-navagations>
      </b-col>
    </b-row>
      </b-card>
  </div>
</template>

<script>
import {http_v1} from '@/axios'
import {ADMIN_PATH, amsApiResourcePath, apiRoute, COLLECTIONS} from '@/ams_route'
import {belongsToDescription} from '@/utils'
import {humanize} from '@/utils'
import DataNavagations from './DataNavagations.vue'

export default {
  components: {
    DataNavagations
  },
  props: {
    id: {
      Type: String
    },
    api_path: {
      Type: String
    }
  },
  data () {
    return {
      ams_type: COLLECTIONS,
      // ams_api_path: 'api/admin/v1/',
      ams_data: {},
      description: undefined,
      describe_belongs_to: [
        {
          prepend: '',
          type: 'interests',
          description_attr: 'name',
          append: ' '
        },
      ],
      humanized_permission: undefined
    }
  },
  computed: {
    doShow() {
      return true
    },
  },
  methods: {
    apiPath () {
       return this.api_path ? this.api_path : ADMIN_PATH
    },
    apiResourcePath() {
      return apiRoute(amsApiResourcePath(this.apiPath(), this.ams_type), this.id)
    },
    doCancel() {
      this.$router.go(-1)
    },
    doUpdate() {
      this.$router.push( {path: '/' + this.ams_type + '/' + this.id + '/update'})
    },
    doHelp() {
      this.$router.push( {path: '/references/Collection/information/' + this.id})
    },
    navigateToImageCollection() {
      let nav = {
        name: 'CollectionScreen', 
        params: {
          id: this.id,
          api_path: ADMIN_PATH
        }
      }
      this.$router.push(nav)
    }
  },
  mounted () {
    http_v1.get(this.apiResourcePath(), {
    }).then(response => {
      if( response.data) {
        this.ams_data = response.data.data
        this.description = belongsToDescription(
          response.data.data, response.data.included, this.describe_belongs_to
        )
        this.$emit('gotAttrs', this.ams_data?.attributes, this.description)
      }
    }).catch(error => {
      if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
  },
  watch: {
    ams_data(val) {
      if( val?.attributes) {
        this.humanized_permission = humanize(val.attributes['access-permission'])
      }
    }
  }
}
</script>

<style scoped>
hr { background-color: white; height: 2px; border: none; }
 .card {
     border: 3px solid white;
 }
 .btn-primary, .btn-primary:hover, .btn-primary:active, .btn-primary:visited {
    background-color: #b097f1 !important;
}
</style>
